export default __webpack_public_path__ + "static/media/paymentgateways.277953b42b92caf19ee1ed70f1fadc1d.webp";